<style lang="scss" scoped>
    @import "./stockdividends.css";
	.warp_img{
		    width: 1.1rem;
		    margin-left:  .5rem;
	}
	.warp_title{
		text-align: center;
		color: #000;
	}
	.warp_color{
		color: #fff;
	}
    .icon_bor{
        width: 50%; 
        height: 2px;
        background-color: #5885ea;
    }
    .icon_bor1{
        width: 50%; 
        height: 2px;
        background-color: #d8d8d8;
    }
    .redX{
        position: relative;
        color: red;
        bottom: 1.2rem;
        font-size: 1.5rem;
        font-weight: 400;
    }
    .pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 101;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw !important;
			height: 80vh !important;
			left: calc(50% - 40vw) !important;
			top: 5vh !important;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
</style>
<style lang='scss'>
	#establishPage{
        .ant-popover-message-title{
            font-size: .8rem !important;
        }
        .ant-btn-sm{
            width: 2.8rem;
            height: 1.5rem;
            span{
                font-size: .7rem !important;
            }
        }
	}
    
</style>
<template>
    <div id="establishPage">
        <div class="topHeader">
            <a-form-model :model="form" style="width:100%;" labelAlign="right" layout="inline">
                <a-row style="display: flex;align-items: center;">
                    <a-col  :xl="{ span: 24 }">
                        <a-row>
                            <a-col :xl="{ span: 7 }">
                                <a-form-model-item label="證券帳號" class="formItem">
                                    <a-input v-model="form.securities_num" placeholder="請輸入證券帳號" :allowClear="true" @change="handleClear(1)"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 7 }">
                                <a-form-model-item label="股票代碼" class="formItem">
                                    <a-input v-model="form.stockCode" placeholder="請輸入股票代碼" :allowClear="true" @change="handleClear(2)"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 7 }">
                                <a-form-model-item label="派息日期" class="formItem">
                                    <a-range-picker :placeholder="['開始時間','結束時間']" v-model="form.timeDate" @change="fanhand()"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :xl="{ span: 3 }" style="display: inline-flex;align-items: center;">
                                <div class="btn_cla" style="background-color:#3bc7a1;margin-right:1rem" @click="searchEvent">
                                    <img src="../../image/icon_sousuo.png" class="btnIcon"/>
                                    <span>搜索</span>
                                </div>
                                <div class="btn_cla" style="background-color:#ffa647;" @click="clearEvent">
                                    <img src="../../image/icon_chongzhi.png" class="btnIcon"/>
                                    <span>重置</span>
                                </div>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-form-model>
        </div>
        <div class="bottomMain">
            <div class="tableBtnView">
                <button class="bottomBtn" style="border: none;background-color: transparent;cursor: pointer;">
                    <img src="../../image/endexs.png" class="btnIcon"/>
                    <span style="color:rgb(88, 133, 234);">導入</span>
                </button>
                <button class="bottomBtn" style="border: none;background-color: transparent;cursor: pointer;" @click="handopen">
                    <a-icon type="file-pdf" style=" width: 0.9rem;color: #3bc7a1;margin-right: 0.3rem;fontsize: 0.8rem;"/>
                    <span style="color:#3bc7a1;">導出</span>
                </button>
                <div class="bottomMsView" style="cursor: pointer;" @click="messionEvent">
                    <a-badge :count="missionnum" :numberStyle="{width:'0.8rem',height:'0.8rem',minWidth:'0.8rem',lineHeight:'0.8rem',padding:'0',fontSize:'0.5rem',top:'0.3rem'}">
                        <img :src="missionflag ? icon_renwu1 : icon_renwu" style="width:2rem;height:2rem;">
                    </a-badge>
                    <span style="font-size:0.9rem;margin-left:0.8rem;font-weight:bold;">任務</span>
                </div>
            </div>
            <a-table
                style="width:100%;"
                :columns="columns"
                :data-source="columnsData"
                :row-selection="{
                    selectedRowKeys: selectedRows,
                    onChange: onSelectChange,
                }"
                :pagination="false"
				id='fromtable'
				:customRow='rowstely'
                :bordered="true">
			
				<div slot='pxjd' slot-scope='record'>
                    <div style="display:flex;align-items: center;justify-content: center;" v-if="(record.schedule!=null&&record.status!=null)">
                        <img :src="record.schedule == 0 ||record.schedule == 1? icon_one : icon_one1 " alt="">
                        <div :class="record.status == 1? 'icon_bor' : 'icon_bor1'">
                            <span v-if="record.status == 2" class="redX" style="opacity: 1;">x</span>
                        </div>
                        <img :src="record.schedule == 1? icon_two : icon_two1 " alt="">
                    </div>
                    <div style="display:flex;align-items: center;justify-content: center;" v-else>
                    </div>
				</div>
				<div slot="toolArr" slot-scope="record">
					<img  @click="openClick(record)" src="../../image/icon_xiangqing.png" class="imageC">
				</div>
            </a-table>
            <div class="paginationView">
                <div>第{{firstPage}}到{{secPage}}條，共{{total}}條記錄</div>
                <div style="margin-left:auto;">
                    <a-pagination v-model="pageNum" @change="pageChange" :total="total" :pageSize="perPage"/>
                </div>
                <div class="pageTzView">
                    <input type="text" v-model="tzPageNum" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')">
                    <span @click="tzEvent">跳轉</span>
                </div>
            </div>
        </div>
        <div :class="['pdfview',pdfShow1 ? 'pdfShow' : '']" @click="pdfShowUNEvent1()">
            <div class="pdfviewIn" >
            <div class="pdfTitle">
                <img @click.stop="printEvent()" src="../../image/icon_dayin.png">
            </div>
            <iframe id="iframePdf1" :src="allurl1" style="width: 100%; height: 100%" frameborder="0"></iframe>
            <iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl1" frameborder="0"></iframe>
            </div>
        </div>
        <handhome v-if='ishome' @child='handclose' :forms='isVal'></handhome>
        <!-- 搜索无结果弹窗 -->
        <div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
    </div>
</template>
<script>
    import handhome from './handhome.vue'
    import https from '@/plugins/http.js';
    import apiUrl from '@/assets/api.js';
    import App from '@/assets/app.js';
    import icon_renwu from '../../image/icon_renwu.png';
    import icon_renwu1 from '../../image/icon_renwu1.png';

    import icon_one from '../../image/icon_1.png';
    import icon_one1 from '../../image/icon_1_1.png';
    import icon_two from '../../image/icon/icon3.png';
    import icon_two1 from '../../image/icon/icon3_1.png';
    import { saveFileToLink,saveFileToBlob  } from 'web-downloadfile';

    export default {
		components:{
            handhome
		},
        data() {
            return {
                ishandout:false,
                ishome:false,
                pdfShow1: false,
                allurl1: '',
                pdfBolUrl1: '',
				isVal:{},
				itemdata:{},
                icon_renwu,
                icon_renwu1,
                icon_one,
                icon_one1,
                icon_two,
                icon_two1,
                ifZt : this.$store.state.rolesdata.indexOf('khadmin2') >= 0,
                ifQt : this.$store.state.rolesdata.indexOf('khadmin1') >= 0,
                ifHt : this.$store.state.rolesdata.indexOf('khadmin3') >= 0,
                ifSQ : this.$store.state.rolesdata.indexOf('khadmin4') >= 0,
                rolesIndx : this.$store.state.rolesdata.indexOf('khadmin1') >= 0 ? '1' : this.$store.state.rolesdata.indexOf('khadmin2') >= 0 ? '2' : this.$store.state.rolesdata.indexOf('khadmin3') >= 0 ? '3' :this.$store.state.rolesdata.indexOf('khadmin4') >= 0 ? '4' : '' ,
                form:{
                    stockCode:'',
                    securities_num:'',
                    // timeDate:[],

                    admintype: this.adminFn(),
                    khtype:9,
                    searchstr:'',
                    username:'',
                    timeDate:[]
                },
                dividends_date_begin:'',
                dividends_date_end:'',
                pageNum:1,
                perPage:10,
                total:1,
                tzPageNum:'',
                columns:[
                    // {title: '證券編號',dataIndex: 'id',align:'center',width:'10%'},
                    {title: '交易編號',dataIndex: 'tradecode',align:'center'},
                    {title: '股票代碼',dataIndex: 'stockcode',align:'center'},
                    {title: '股票名稱',dataIndex: 'stockname',align:'center',width:'18%'},
                    {title: '派息金額',dataIndex: 'dividends_price',align:'center'},
                    {title: '派息日期',dataIndex: 'dividends_date',align:'center'},
                    {title: '證券帳號',dataIndex: 'username',align:'center'},
                    {title: '派息進度',dataIndex: '',align:'center',scopedSlots: { customRender: 'pxjd' },width:'14%'},
                    {title: '操作人',dataIndex: 'handleuser',align:'center'},
                    {title: '審批時間',dataIndex: 'audittime',align:'center'},
                    {title: '操作',dataIndex: '',align:'center',width:'auto',scopedSlots: { customRender: 'toolArr' }},
                ],
                columnsData:[],
				visible_bold:false,
                // pdf彈出
                pdfShow : false,
                pdfUrl : '',
                pdfBolUrl : '',
                blob:'',
                // 任務數
                missionnum:0,
                missionflag:false,
                // 證件圖標 arr
              
                selectedRows:[],
                submitusers:[]
				
            }
        },
        created(){
            let _this = this;
            _this.messLoad();
        },
        computed: {
            firstPage: function () {
                let _this = this;
                let a = (_this.pageNum-1)*10;
                let b = 1;
                return _this.total > 0 ? Number(a) + Number(b) : 0
            },
            secPage : function(){
                let _this = this;
                let a = _this.pageNum*10;
                let b = a > _this.total ? _this.total : a;
                return b
            },
        },
		mounted() {},
		methods: {
            handleCancel(ev){
                this.ishandout = false
			},
            handleClear(val){
                if (val ==1 ) {
                    if (!this.form.securities_num) {
                        this.messLoad()
                    }
                }
                if (val ==2 ) {
                    if (!this.form.stockCode) {
                        this.messLoad()
                    }
                }
            },
            onSelectChange(selectedRowKeys, selectedRows) {
                this.selectedRows = selectedRowKeys;
                console.log(this.selectedRows,'复选框查看',selectedRows);
                this.submitusers = []
                for (let i = 0; i < selectedRows.length; i++) {
                    this.submitusers.push(selectedRows[i].pdfcode )
                }
            },
			rowstely(record, index) {
				if (record.schedule == 1) {
					return {
						style: {
							'color': '#999'
						},
					}
				}
			},
			adminFn(){
				if(this.$store.state.rolesdata.indexOf('khadmin2')>=0){
					return 'khadmin2'
				}else if(this.$store.state.rolesdata.indexOf('khadmin3')>=0){
					return 'khadmin3'
				}else if(this.$store.state.rolesdata.indexOf('khadmin4')>=0){
					return 'khadmin4'
				}else{
					return 'khadmin1'
				}
			},
            fanhand(){
                let _this = this;
                dividends_date_begin =_this.form.timeDate[0] ? App.oDate.secsTime3(_this.form.timeDate[0]._d) : null,
                dividends_date_end = _this.form.timeDate[1] ? App.oDate.secsTime3(_this.form.timeDate[1]._d) : null
            },
            messLoad(){
                this.selectedRows = [];
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.getQmisUserStockDividendsList,Object.assign({
                    stockcode:_this.form.stockCode,
                    username:_this.form.securities_num,
                    dividends_date_begin:_this.form.timeDate[0] ? App.oDate.secsTime3(_this.form.timeDate[0]._d) : null,
                    dividends_date_end:_this.form.timeDate[1] ? App.oDate.secsTime3(_this.form.timeDate[1]._d) : null
                },{
                    missionflag: _this.missionflag ? '1' : '0',
                    pageNum : _this.pageNum,
                    perPage : _this.perPage
                }),json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.missionnum = data.missionnum;
                        _this.total = data.total;
                        _this.tzPageNum = '';
                        _this.columnsData = data.ipoSellingList;
                        if (_this.form.securities_num || _this.form.stockCode || _this.form.stockCode.length>0) {
                            if (_this.columnsData.length<=0) {
                                _this.ishandout = true
                            }
                        }
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            searchEvent(){
                this.pageNum = 1;
                this.missionflag = false;
                this.messLoad();
            },
            clearEvent(){
                this.form = {
                    stockCode:'',
                    securities_num:'',
                    admintype: this.adminFn(),
                    khtype:9,
                    searchstr:'',
                    username:'',
                    timeDate:[]
                }
                this.messLoad();
            },
            messionEvent(){
                this.pageNum = 1;
                this.missionflag = !this.missionflag;
                this.messLoad();
            },
            tzEvent(){
                let _this = this;
                let maxPageNum = Math.ceil(_this.total/_this.perPage);
                if(_this.tzPageNum <= maxPageNum){
                    _this.pageNum = Number(_this.tzPageNum);
                    _this.messLoad();
                }else{
                    App.oTool.warningT('請輸入有效的頁碼');
                }
            },
            pageChange(page, pageSize){
                this.pageNum = page;
                this.messLoad();
            },

            onChange(index,bol,record){
                record.moreCheckOption[index].checked = !bol;
            },
            // 操作
            openClick(item){
                this.ishome = true;
                this.isVal=item;
                console.log(item);
            },
            handclose(val){
                this.ishome = false;
				// this.columnsData.map((ele,index) => {
				// 	ele.shShowBol = false;
				// })
				// this.isshShowBol = false
				// this.visible_bold = false
                this.messLoad();
                // this.$router.go(0)
			},
            //导出按钮
            handopen() {
                // userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
                // if (this.userfileAuditAdmin) {
                    console.log("导出按钮");
                        let str = this.$api.pdfs; //getUnsk
                        // let url = 'http://202.130.113.149:3785/admin/getQmisUserFileInfoPdf';
                        let url = this.$api.getQmisUserStockDividendsPdf;
                        // url += '?m=' + Date.parse(new Date())
                        url += '?token=' + this.$store.state.token
                            + '&stockcode=' + this.form.stockCode
                            + '&username=' + this.form.securities_num
                            + '&dividends_date_begin=' + this.dividends_date_begin,
                            + '&dividends_date_end=' + this.dividends_date_end
                        this.allurl1 = str + url
                        let _this = this;
                        _this.pdfUrl = url
                        https.fetchGetPdf(_this.pdfUrl).then((data) => {
                            let blob = new Blob([data], {
                                type: 'application/pdf'
                            });
                            _this.blob = blob;
                            let b = window.URL.createObjectURL(blob);
                            _this.pdfBolUrl1 = b;
                        }).catch(err => {
                            console.log(err);
                        });
                        //
                        setTimeout(() => {
                            this.pdfShow1 = true;
                        }, 500);
                // }else{
                //      App.oTool.warningT('暫無權限');
                // }
            },
            pdfShowUNEvent1() {
                this.pdfShow1 = false;
            },
            printEvent() {
                let _this = this; //toPrintIframe
                const printIframe = document.getElementById("toPrintIframe");
                let frameWindow = printIframe.contentWindow;
                console.log(frameWindow)
                frameWindow.print();
                setTimeout(() => {
                    window.URL.revokeObjectURL(_this.blob);
                }, 500)
            },

        },
    };

</script>


